<template>
  <div style="color: black;">
    <p :class="`text-center ${headerFontSize}`">
      <b>{{ form.title }}</b>
    </p>
    <v-form ref="form"
            lazy-validation>
      <v-text-field v-for="(input, i) in form.inputs"
                    :key="`input-${i}`"
                    v-model="input.value"
                    :rules="input.rules"
                    :label="input.label"
                    :required="input.required"
                    :type="input.type"></v-text-field>
      <VueOnGeoButton :block="true"
                      primaryColor="primary"
                      :text="form.submit.text"
                      :click="submit"></VueOnGeoButton>
    </v-form>
  </div>
</template>

<script>
import VueOnGeoButton from "./vue-ongeo-button.vue";
import VueOnGeoGlobalMixin from "./vue-ongeo-global-mixin.js";

export default {
  name: "vue-ongeo-edit-form",
  components: { VueOnGeoButton },
  mixins: [VueOnGeoGlobalMixin],
  props: {
    form: {
      type: Object,
      default: function () {
        return { submit: {} };
      }
    }
  },
  methods: {
    prepareForm () {
      var res = {};
      this.form.inputs.forEach(input => {
        res[input.name] = input.value;
      });
      return res;
    },
    submit () {
      if (this.$refs.form.validate()) {
        if (this.form.submit.click) this.form.submit.click(this.prepareForm());
      }
    }
  }
};
</script>
